import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getQueryVariable } from '../util/const';
import localeMessages from './index';

Vue.use(VueI18n);


let lang = getQueryVariable('lang') || window.localStorage.getItem('lang');

if (!lang) {
  lang = 'tc';
}

window.localStorage.setItem('lang', lang);
console.log('lang', lang);

const i18n = new VueI18n({
  locale: lang, // 语言标识
  messages: localeMessages,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/locale/i18n.js